import { computed } from "vue";
import dayjs from "@/plugins/dayjs";

export function useEventCardHelpers(props) {
  const profilePage = computed(() => {
    return props.event.noncompetition
      ? "NoncompetitionEventProfilePage"
      : "EventProfilePage";
  });

  const showAlert = computed(() => {
    return props.event.alertText && props.event.alertText != "<p></p>"
      ? true
      : false;
  });

  const regionName = computed(() => {
    return props.event.region?.name ?? "";
  });

  const eventDate = computed(() => {
    return dayjs.nicerDate(props.event.startDate, props.event.endDate);
  });

  const eventLink = computed(() => {
    switch (props.event.status) {
      case "results_published":
      case "closed":
      case "archived":
        return "results";
      case "registration_open":
        return "registration";
      default:
        return "eventPage";
    }
  });

  const linkToEvent = computed(() => {
    if (!props.event.id) return;
    if (props.event.noncompetition) {
      return {
        name: "NoncompetitionEventProfilePage",
        params: { eventId: props.event.id }
      };
    }
    if (eventLink.value == "results" && props.event.discipline) {
      return {
        name: "EventResultsPage",
        params: { eventId: props.event.id }
      };
    }
    return {
      name: "EventProfilePage",
      params: { eventId: props.event.id }
    };
  });

  return {
    profilePage,
    regionName,
    eventDate,
    eventLink,
    showAlert,

    linkToEvent
  };
}
